import {atom, DefaultValue, RecoilState, selector} from "recoil";


const storedToken = localStorage.getItem('accessToken');
const coreStoredToken = localStorage.getItem('coreToken');


export const tokenAtom: RecoilState<string> = atom<string>({
    key: 'token_atom',
    default: storedToken ? storedToken : '',
    effects_UNSTABLE: [
        ({onSet}) => {
            onSet((newToken: string | DefaultValue) => {
                if (!(newToken instanceof DefaultValue) && newToken) {
                    localStorage.setItem('accessToken', newToken);
                }
            })
        },
    ]
});

export const coreTokenAtom: RecoilState<string> = atom<string>({
    key: 'coreToken_atom',
    default: coreStoredToken ? coreStoredToken : '',
    effects_UNSTABLE: [
        ({onSet}) => {
            onSet((newToken: string | DefaultValue) => {
                if (!(newToken instanceof DefaultValue) && newToken) {
                    localStorage.setItem('coreToken', newToken);
                }
            })
        },
    ]
});

export const hasToken = selector<boolean>({
    key: 'hasToken_selector',
    get: ({get}) => {
        const token = get(tokenAtom);
        if (token === '') {
            return false;
        }
        return true;
    }
});